/**
 * These are assumed levels based on normal console object. They are ordered from least-priority to
 * highest priority.
 */
const levels = {
  // Very noisy. Only spot enabled for short durations to debug known issues. Extremely targeted.
  debug: 0,
  // Helps append textual information to traces, as an aid to APM tracing for comprehension.
  info: 1,
  // Conditions that may indicate problems if they aren't corrected. Also encouraged for when we are
  // detecting the presence of an issue that has no fix but won't until we have verified it's occurrence.
  warn: 2,
  // Conditions that are not expected to happen in normal operation. Often intermittent, and may correct -- possibly
  // timouts, or other transient errors.
  error: 3,
  // An intolerable invariant has been hit and someone should see to it right away. We prefer to degrade the performance and keep users on the site without a
  // 5xx error, if possible. This is a last resort.
  //
  // This is important for tooling integration since we have a blanket monitor that triggers and assigns to owners when
  // any of these logs are detected.
  alert: 4
};
module.exports = levels;